import { Component, h } from '@stencil/core';
/**
 * Displays loading skeleton. Attemps to fill parent div using 'flex-grow' and height/width at 100%.
 */
@Component({
  tag: 'loading-skeleton',
  styleUrl: 'loading-skeleton.css',
  shadow: true,
})
export class LoadingSkeleton {
  render() {
    return <span></span>;
  }
}
